// Server-local, git-ignored (.gitignore: src/config.js). Recreated on Box 2 (2026-10-06) from the
// old server RUNBOOKS "Frontend Configuration" section. Imported by App.js, Footer.js and several pages.
const config = {
  development: {
    apiBaseUrl: "https://digibyte.io",
    wsBaseUrl: "wss://digibyte.io/ws",
    wsTestnetBaseUrl: "wss://digibyte.io/ws-testnet",
  },
  production: {
    apiBaseUrl: "https://digibyte.io",
    wsBaseUrl: "wss://digibyte.io/ws",
    wsTestnetBaseUrl: "wss://digibyte.io/ws-testnet",
  },
};

const env = process.env.NODE_ENV === "production" ? "production" : "development";
export default config[env];
